import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Stack } from '@mui/system';
import { Fragment } from 'react';
import { bloxValues } from 'themes/constants';
import { hasLength } from 'utility/functions';
import { PlusNavObj } from '../types';
import DnDBasePlusNavItem from './DnDBasePlusNavItem';

interface RecommendedAppsProps {
  recommendedApps: PlusNavObj[];
  handleItemClick: (event: React.SyntheticEvent<HTMLElement>, item: PlusNavObj) => void;
  editMode: boolean;
  handlePinToggle: (item: PlusNavObj) => void;
  pinnedApps: string[];
}

const RecommendedApps = ({
  recommendedApps,
  handleItemClick,
  editMode,
  handlePinToggle,
  pinnedApps,
}: RecommendedAppsProps) => {
  const theme = useTheme();
  return (
    <Fragment>
      <Stack
        direction="row"
        sx={{
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1,
        }}
      >
        <Typography
          sx={{
            display: 'flex',
            alignItems: 'center',
            fontWeight: bloxValues.fontWeightMedium,
            fontSize: bloxValues.regularFontSizeRem,
            color: theme.palette.text.secondary,
          }}
        >
          Recommended
        </Typography>

        <Box
          data-testid="plus-button-recommended-divider"
          id="plus-button-recommended-divider"
          sx={{
            display: 'flex',
            alignItems: 'center',
            flexGrow: 1,
            borderBottom: `1px solid ${theme.palette.divider}`,
          }}
        />
      </Stack>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
          gap: 1,
          justifyItems: 'center',
          alignItems: 'center',
        }}
      >
        {hasLength(recommendedApps) ? (
          recommendedApps.map((item) => (
            <DnDBasePlusNavItem
              key={item.key}
              id={`plus-button-recommended-item-${item.key}`}
              navItem={item}
              handleOnClick={(event) => handleItemClick(event, item)}
              asIcon={false}
              handlePinToggle={handlePinToggle}
              pinnedApps={pinnedApps}
              hidePin={!editMode}
              fullHeight={true}
              fullWidth={true}
              href={item?.path}
              hidden={item?.hidden}
            />
          ))
        ) : (
          <Typography
            sx={{
              color: theme.palette.text.secondary,
              fontSize: bloxValues.tinyFontSizeRem,
              border: `2px solid ${theme.palette.action.hover}`,
              backgroundColor: theme.palette.action.hover,
              p: 1,
              width: '100%',
              borderRadius: 1,
              gridColumn: '1 / -1',
              textAlign: 'center',
            }}
          >
            No recommended apps available.
          </Typography>
        )}
      </Box>
    </Fragment>
  );
};

RecommendedApps.displayName = 'RecommendedApps';
export default RecommendedApps;
